import { mount } from "@vue/test-utils";
import FacebookImage from "@/components/core/FacebookImage";

describe("FacebookImage test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(FacebookImage);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component FacebookImage", () => {
    expect(wrapper).toBeDefined();
  });
});
